export default "__VITE_ASSET__0921a8ad__"